import { jsx as _jsx } from "react/jsx-runtime";
import { useVehicleRfIndicatorState } from 'console/shared/hooks/device/legacy';
import { memo, useContext, useMemo } from 'react';
import { RfIndicatorContent } from './types';
export const RfIndicatorProvider = memo(function RfIndicatorProvider(props) {
    const { children, is_loading, rf_indicator_config } = props;
    const { serial } = rf_indicator_config;
    const { rf_status } = useVehicleRfIndicatorState();
    const rf_values = useMemo(() => {
        const rf_indicator = serial && rf_status?.[serial];
        if (rf_indicator) {
            const { bat, dbm, type } = rf_indicator;
            return { bat, bat_v: bat, dbm, type };
        }
        return {};
    }, [serial, rf_status]);
    const rf_incdicator_state = useMemo(() => ({
        is_loading,
        rf_values,
    }), [is_loading, rf_values]);
    const rf_indicator = useMemo(() => ({
        ...rf_indicator_config,
        ...rf_incdicator_state,
    }), [rf_indicator_config]);
    return (_jsx(RfIndicatorContent.Provider, { value: rf_indicator, children: children }));
});
export const useRfIndicator = () => useContext(RfIndicatorContent);
